import jsPDF from 'jspdf';

interface OrderItem {
  quantity: number;
  products: {
    name: string;
    code: string;
    unit: string;
  };
}

interface Order {
  id: string;
  order_number: number;
  responsible_name: string;
  construction_name: string;
  created_at: string;
  status: string;
  department: {
    id: string;
    name: string;
    acronym: string;
  };
  order_items: OrderItem[];
}

export const generateReceiptPDF = (order: Order) => {
  // Configuração para impressora térmica (80mm = ~226 pontos)
  const doc = new jsPDF({
    format: [80, 297], // Largura padrão de cupom (80mm)
    unit: 'mm'
  });

  // Configurações
  const margin = 5;
  let yPos = margin;
  const lineHeight = 5;
  const width = 70; // Largura útil do cupom

  // Função auxiliar para centralizar texto
  const centerText = (text: string, y: number) => {
    const textWidth = doc.getStringUnitWidth(text) * doc.getFontSize() / doc.internal.scaleFactor;
    const x = (80 - textWidth) / 2;
    doc.text(text, x, y);
  };

  // Função para adicionar linha
  const addLine = (y: number) => {
    doc.setLineWidth(0.1);
    doc.line(margin, y, 75, y);
  };

  // Cabeçalho
  doc.setFontSize(12);
  centerText('SEINFRA', yPos + 4);
  yPos += lineHeight + 4;

  doc.setFontSize(10);
  centerText('Comprovante de Retirada', yPos + 4);
  yPos += lineHeight + 4;

  addLine(yPos);
  yPos += 2;

  // Informações do pedido
  doc.setFontSize(8);
  doc.text(`Pedido Nº: ${order.order_number}`, margin, yPos + 3);
  yPos += lineHeight;
  doc.text(`Data: ${new Date(order.created_at).toLocaleDateString('pt-BR')}`, margin, yPos + 3);
  yPos += lineHeight;
  doc.text(`Departamento: ${order.department.name}`, margin, yPos + 3);
  yPos += lineHeight;
  doc.text(`Responsável: ${order.responsible_name}`, margin, yPos + 3);
  yPos += lineHeight;
  doc.text(`Obra: ${order.construction_name}`, margin, yPos + 3);
  yPos += lineHeight + 2;

  addLine(yPos);
  yPos += 4;

  // Cabeçalho dos itens
  doc.text('ITENS DO PEDIDO', margin, yPos + 3);
  yPos += lineHeight + 2;

  // Lista de itens
  order.order_items.forEach((item) => {
    doc.text(`${item.products.name}`, margin, yPos + 3);
    yPos += lineHeight;
    doc.text(`Código: ${item.products.code}`, margin, yPos + 3);
    yPos += lineHeight;
    doc.text(`Qtd: ${item.quantity} ${item.products.unit}`, margin, yPos + 3);
    yPos += lineHeight + 2;
  });

  addLine(yPos);
  yPos += 4;

  // Área de assinatura do responsável
  doc.text('Assinatura do Responsável:', margin, yPos + 3);
  yPos += lineHeight + 8;
  addLine(yPos);
  yPos += lineHeight;
  doc.text(order.responsible_name, margin + 5, yPos + 3);

  // Área de recebido
  yPos += lineHeight + 8;
  doc.text('Recebido por:', margin, yPos + 3);
  yPos += lineHeight + 8;
  addLine(yPos);

  // Aumenta a altura do documento para garantir que tudo seja exibido
  const minHeight = yPos + 20; // Adiciona espaço extra para o campo de recebido
  if (minHeight > doc.internal.pageSize.height) {
    doc.internal.pageSize.height = minHeight;
  }

  // Data e hora
  yPos += lineHeight + 5;
  const currentDate = new Date().toLocaleDateString('pt-BR');
  const currentTime = new Date().toLocaleTimeString('pt-BR');
  centerText(`${currentDate} ${currentTime}`, yPos + 3);

  return doc;
};
